export default __webpack_public_path__ + "static/media/wwf_main_mobile_small.7bfdfc11.jpg";